import React from 'react';

var Download = function Download(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 13.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L11 13.586V4a1 1 0 0 1 2 0v9.586zM5 21a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Download.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Download as icon };
export default iconHandler(Download);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Download.js
// module id = 595
// module chunks = 0